import { render, staticRenderFns } from "./all-tests.vue?vue&type=template&id=b608f712&"
import script from "./all-tests.vue?vue&type=script&lang=js&"
export * from "./all-tests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports